var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftcardN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 476,
    viewBox: "0 0 338 476",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.17845 443.213C1.17845 443.213 28.1972 227.735 67.2756 189.971C128.052 131.323 174.044 240.891 165.871 278.448C193.797 149.627 241.062 9.78853 298.424 0.904202C354.939 -7.87764 333.412 87.7991 333.412 87.7991C244.638 134.719 229.911 327.149 220.985 356.164C213.082 381.854 180.014 397.262 162.631 391.887C123.308 379.725 105.197 324.362 98.0402 293.581C97.8774 292.481 97.3294 291.474 96.4936 290.74C95.6579 290.006 94.589 289.593 93.4779 289.575C92.3669 289.556 91.2858 289.934 90.428 290.64C89.5702 291.345 88.9915 292.334 88.795 293.428C81.8568 319.589 67.4604 371.178 41.9914 451.378C29.9791 489.187 -2.04123 478.815 1.13471 443.131",
    fill: "url(#paint0_linear_1002_2438)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_2438",
    x1: -124.05,
    y1: 221.596,
    x2: 320.379,
    y2: 1.75185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92F23B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0FDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftcardN);
export default __webpack_public_path__ + "static/media/giftcard-n.2584d645b86f4ca757d2d3d12dbbafe4.svg";
export { ForwardRef as ReactComponent };